import styled from 'styled-components';

export const LoaderInfo = styled.div`
  margin: 15px 0;
`;

export const LoaderWrapper = styled.div`
  text-align: center;
  margin-top: 10px;
`;
